import { put, takeLatest, all, call } from 'redux-saga/effects';
import { CREATE_REFERENCE, CreateReferenceAction, DELETE_REFERENCE, DeleteReferenceAction, GET_STIPULATIONS, GET_STIPULATION_CATEGORIES, GET_STIPULATION_DOCUMENTS, GET_USER, GetStipulationCategoriesAction, GetStipulationDocumentsAction, GetStipulationsAction, GetUserAction, LOAD_REFERENCES, LoadReferencesAction, UPDATE_STIP_DOCUMENT, UpdateStipDocumentAction, SCHEDULE_APPOINTMENT, ScheduleAppointmentAction, UPDATE_REFERENCE, UpdateReferenceAction, createReferenceSuccess, deleteReferenceSuccess, getStipulationCategoriesSuccess, getStipulationDocumentsSuccess, getStipulationsSuccess, getUserSuccess, loadReferencesSuccess, portalValidationError, removeSchedulingApptLoader, updateStipDocumentSuccess, scheduleAppointmentSuccess, updateReferenceSuccess, UpdatePrefersSpanishAction, UPDATE_PREFERS_SPANISH, GetPortalPreQualificationResultAction, GET_PORTAL_PRE_QUALIFICATION_RESULT, getPortalPreQualificationResultSuccess, setIsGettingPortalPreQualificationResult } from "./actions";
import { displayError } from '../../Helpers/Utilities';
import { httpDelete, httpGet, httpPost, httpPut } from '../../Http/HttpClient';
import { Stipulation } from '../../Models/Stipulation';
import { CustomerPortalUser } from '../../Models/CustomerPortalUser';
import { StipDocument } from '../../Models/StipDocument';
import { Reference } from '../../Models/Reference';
import { StipulationCategory } from '../../Models/StipulationCategory';
import { PreQualifyResult } from '../../Models/PreQualifyResult';
import { isNotNil } from 'ramda';
import { PortalPreQualifyInfo } from '../../Models/PortalPreQualifyInfo';

/** Get User */
function* getUserSaga(action: GetUserAction) {
  try {
    const response: Response = yield call(httpGet, `CustomerPortal/user?customerPortalLinkId=${action.payload.customerPortalLinkId}`);
    if (response && response.ok) {
      const user: CustomerPortalUser = yield call([response, response.json]);
      yield put(getUserSuccess({ ...user, customerPortalLinkId: action.payload.customerPortalLinkId }, { httpStatusCode: 200 }));
    } else {
      if (!response) {
        yield put(portalValidationError({ httpStatusCode: 500, errorMessage: 'It appears that you cannot connect to the api. Make sure you have an active internet connection.' }));
      }
      if (response.status !== 200) {
        yield put(portalValidationError({ httpStatusCode: response.status, errorMessage: response?.body?.toString() }));
      }
    }

  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchGetUser() {
  yield takeLatest(GET_USER, getUserSaga);
}

/** End User */

/** Stipulation Categories */
function* getStipulationCategoriesSaga(action: GetStipulationCategoriesAction) {
  try {
    const response: { json: any } = yield call(httpGet, `Lookup/stipulationCategoriesForCustomers?customerPortalLinkId=${action.payload.customerPortalLinkId}`);
    const stipulationCategories: StipulationCategory[] = yield call([response, response.json]);
    yield put(getStipulationCategoriesSuccess(stipulationCategories));
  } catch (error) {
    yield put(setIsGettingPortalPreQualificationResult(false));
    yield put(displayError(error as string));
  }
}

export function* watchGetStipulationCategories() {
  yield takeLatest(GET_STIPULATION_CATEGORIES, getStipulationCategoriesSaga);
}

/** End Stipulation Categories */

/** Stipulations */
function* getStipulationsSaga(action: GetStipulationsAction) {
  try {
    const response: { json: any } = yield call(httpGet, `Lookup/stipulations?customerPortalLinkId=${action.payload.customerPortalLinkId}`);
    const stipulations: Stipulation[] = yield call([response, response.json]);
    yield put(getStipulationsSuccess(stipulations));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchGetStipulations() {
  yield takeLatest(GET_STIPULATIONS, getStipulationsSaga);
}

/** End Stipulations */

/** Stipulation Documents */
function* getStipulationDocumentsSaga(action: GetStipulationDocumentsAction) {
  try {
    const response: { json: any } = yield call(httpPost, `StipulationDocument/portal/getStipulationDocuments?customerPortalLinkId=${action.payload.customerPortalLinkId}`, { applicationId: action.payload.applicationId, customerId: action.payload.customerId });
    const stipDocuments: StipDocument[] = yield call([response, response.json]);
    yield put(getStipulationDocumentsSuccess(stipDocuments));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchGetStipulationDocuments() {
  yield takeLatest(GET_STIPULATION_DOCUMENTS, getStipulationDocumentsSaga);
}

/** End Stipulation Documents */

/** Update Stip Document */
function* updateStipDocumentSaga(action: UpdateStipDocumentAction) {
  try {
    yield call(httpPost, `StipulationDocument/updateNameAndStip?customerPortalLinkId=${action.payload.customerPortalLinkId}`, { AppCustomerId: action.payload.appCustomerId, appCustomerStipDocumentId: action.payload.stipDocumentId, documentName: action.payload.newFileName, stipulationId: action.payload.stipulationId });
    yield put(updateStipDocumentSuccess(action.payload.stipDocumentId, action.payload.newFileName, action.payload.stipulationId));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdateStipDocument() {
  yield takeLatest(UPDATE_STIP_DOCUMENT, updateStipDocumentSaga);
}

/** End Update Stip Document */

/** Get References */
function* loadReferencesSaga(action: LoadReferencesAction) {
  try {
    const response: { json: any } = yield call(httpGet, `Reference/getRefs/${action.payload.customerId}?customerPortalLinkId=${action.payload.customerPortalLinkId}`);
    const references: Reference[] = yield call([response, response.json]);
    yield put(loadReferencesSuccess(references));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchLoadReferences() {
  yield takeLatest(LOAD_REFERENCES, loadReferencesSaga);
}

/** End Get References */

/** Create Reference */
function* createReferenceSaga(action: CreateReferenceAction) {
  try {
    const response: Response = yield call(httpPut, `Reference/create?customerPortalLinkId=${action.payload.customerPortalLinkId}`, action.payload.reference);
    if (response && response.ok) {
      const reference: Reference = yield call([response, response.json]);
      yield put(createReferenceSuccess(reference));
    } else {
      if (!response) {
        yield put(displayError('It appears that you cannot connect to the api. Make sure you have an active internet connection.'));
      } else {
        yield put(displayError('We were unable to create your reference. Please try again.'));
      }
    }

  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchCreateReference() {
  yield takeLatest(CREATE_REFERENCE, createReferenceSaga);
}

/** End Create Reference */

/** Update Reference */
function* updateReferenceSaga(action: UpdateReferenceAction) {
  try {
    const response: { json: any } = yield call(httpPost, `Reference/update?customerPortalLinkId=${action.payload.customerPortalLinkId}`, action.payload.reference);
    const referenceId: string = yield call([response, response.json]);
    yield put(updateReferenceSuccess(action.payload.reference as Reference));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdateReference() {
  yield takeLatest(UPDATE_REFERENCE, updateReferenceSaga);
}

/** End Update Reference */

/** Delete Reference */
function* deleteReferenceSaga(action: DeleteReferenceAction) {
  try {
    const response: { json: any } = yield call(httpDelete, `Reference/delete/${action.payload.customerId}/${action.payload.referenceId}?customerPortalLinkId=${action.payload.customerPortalLinkId}`);
    yield put(deleteReferenceSuccess(action.payload.referenceId));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchDeleteReference() {
  yield takeLatest(DELETE_REFERENCE, deleteReferenceSaga);
}

/** End Delete Reference */

/** Schedule Appointment */
function* scheduleAppointmentSaga(action: ScheduleAppointmentAction) {
  try {
    const response: { ok: boolean, json: any, message?: any } = yield call(httpPost, `Schedule/portal?customerPortalLinkId=${action.payload.customerPortalLinkId}`,
      {
        customerPortalLinkId: action.payload.customerPortalLinkId,
        appointmentDate: action.payload.appointmentDate
      });
    if (response && response.ok) {
      yield put(scheduleAppointmentSuccess(action.payload.appointmentDate));
    } else {
      yield put(removeSchedulingApptLoader());
      if (!response) {
        yield put(displayError('It appears that you cannot connect to the api. Make sure you have an active internet connection.'));
      } else {
        yield put(displayError('We were unable to schedule your appointment. Please try again.'));
      }
    }
  } catch (error) {
    yield put(removeSchedulingApptLoader());
    yield put(displayError(error as string));
  }
}

export function* watchScheduleAppointment() {
  yield takeLatest(SCHEDULE_APPOINTMENT, scheduleAppointmentSaga);
}

function* updatePrefersSpanishSaga(action: UpdatePrefersSpanishAction) {
  try {
    yield call(httpPost, `contact/updatePreferredLanguage?customerPortalLinkId=${action.payload.customerPortalLinkId}`, { contactId: action.payload.contactId, prefersSpanish: action.payload.prefersSpanish });
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdatePrefersSpanish() {
  yield takeLatest(UPDATE_PREFERS_SPANISH, updatePrefersSpanishSaga);
}

function* getPortalPreQualificationResultSaga(action: GetPortalPreQualificationResultAction) {
  try {
    const response: { json: any } = yield call(httpGet, `CustomerPortal/prequalify?customerPortalLinkId=${action.payload.customerPortalLinkId}`);
    const reponse: { result: PortalPreQualifyInfo } = yield call([response, response.json]);
    if (isNotNil(reponse)) {
      if (reponse.result) {
        yield put(getPortalPreQualificationResultSuccess(reponse.result));
      } else {
        yield put(setIsGettingPortalPreQualificationResult(false));
      }
    } else {
      yield put(setIsGettingPortalPreQualificationResult(false));
      yield put(displayError("Unable to load your Pre-qualification information."));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchGetPortalPreQualificationResult() {
  yield takeLatest(GET_PORTAL_PRE_QUALIFICATION_RESULT, getPortalPreQualificationResultSaga);
}

export default function* customerPortalSagas() {
  yield all([
    watchGetUser(),
    watchGetStipulationCategories(),
    watchGetStipulations(),
    watchGetStipulationDocuments(),
    watchUpdateStipDocument(),
    watchLoadReferences(),
    watchCreateReference(),
    watchUpdateReference(),
    watchDeleteReference(),
    watchScheduleAppointment(),
    watchUpdatePrefersSpanish(),
    watchGetPortalPreQualificationResult()
  ]);
}